import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowLeftIcon } from 'assets/icons/chevron.svg';
import { clsx } from 'clsx';

import { VALUE_CHAIN_AI_AGENT } from '../../../../constants/general';

import type { IReviewGeneratedPanel } from './interfaces/IReviewGeneratedPanel';

import styles from './sass/ReviewGeneratedPanel.module.scss';

function ReviewGeneratedPanel({ sessionSubType, onBack }: IReviewGeneratedPanel) {
  const { t } = useTranslation();
  const isBillOfMaterials = sessionSubType === VALUE_CHAIN_AI_AGENT.BILL_OF_MATERIALS_SESSION_TYPE;
  const isSupplierDiscovery = sessionSubType === VALUE_CHAIN_AI_AGENT.SUPPLIER_DISCOVERY_SESSION_TYPE;

  const handleBack = () => {
    onBack?.();
  };

  if (!sessionSubType) {
    return null;
  }

  return (
    <div className={styles.panel}>
      {!isSupplierDiscovery ? (
        <button
          type="button"
          className={styles.backButton}
          onClick={handleBack}
          aria-label={t('common.back')}
        >
          <ArrowLeftIcon className={styles.backButtonIcon} />
        </button>
      ) : null}
      <div className={styles.content}>
        <div className={styles.titleRow}>
          <h3 className={styles.title}>
            {isBillOfMaterials
              ? t('valueChainMap.reviewBomGeneratedTitle')
              : t('valueChainMap.reviewAiGeneratedTitle')}
          </h3>
          <span
            className={clsx(styles.badge, {
              [styles.aiBadge]: !isBillOfMaterials,
              [styles.bomBadge]: isBillOfMaterials,
            })}
          >
            {isBillOfMaterials
              ? t('valueChainMap.reviewBomGeneratedBadge')
              : t('valueChainMap.reviewAiGeneratedBadge')}
          </span>
        </div>
        <p className={styles.description}>
          {isBillOfMaterials
            ? t('valueChainMap.reviewBomGeneratedDescription')
            : t('valueChainMap.reviewAiGeneratedDescription')}
        </p>
      </div>
    </div>
  );
}

export default ReviewGeneratedPanel;
